
import { Component, Prop, Vue } from 'vue-property-decorator';
import SignDefinition from '@/repositories/data/SignDefinition';
import SignShapeImage from '@/components/SignShapeImage.vue';
import SignLocationImage from '@/components/SignLocationImage.vue';

@Component({
    components: { SignShapeImage, SignLocationImage },
})
export default class MainSignDetails extends Vue {
    @Prop({ required: true }) public readonly signDefinition!: SignDefinition;

    public get splitQuarters(): boolean {
        const shapes = [
            this.signDefinition.leftHandShape,
            this.signDefinition.rightHandShape,
            this.signDefinition.nextLeftHandShape,
            this.signDefinition.nextRightHandShape,
        ];
        return shapes.filter(shape => shape !== null).length > 2;
    }
}
